<template>
  <div class="mt-telematics">
    <track-filters
      :interval="interval"
      :loading="loadingTelematics"
      :show="showTelematics"
      telematics
      @load="loadTelematics"
      @toggle="toggleTelematics"
    />
    <r-table-list
      v-if="tableData.length"
      :data="tableData"
      :fields-names="fieldsNames"
      :include-columns="includedColumns"
      :actions="true"
      paginator
    >
      <template v-slot:actions="{ row }">
        <div class="mt-telematics__action-cell">
          <button
            class="mt-telematics__action-cell-button"
            @click="showOnMap(row)"
          >
            <r-icon
              name="focus-zone"
              :size="20"
            />
            <r-text> На карте </r-text>
          </button>
        </div>
      </template>
    </r-table-list>
  </div>
</template>

<script>
import TrackFilters from '../track/track-filters'
import { notifyFactory, ritmDate } from '@/utils'

export default {
  components: { TrackFilters },
  props: {
    id: {
      type: String,
      default: null
    },
    info: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      tableData: [],
      interval: {
        from: ritmDate.dateDiff(null, -15, 'm'),
        to: ritmDate.date()
      },
      source: '40c30689-7918-4117-97e4-39222d6751aa',
      loadingTelematics: false,
      showTelematics: false,
      includedColumns: ['time', 'speed', 'coordinates'],
      fieldsNames: {
        time: 'Дата и время',
        speed: 'Скорость',
        coordinates: 'Координаты'
      }
    }
  },
  watch: {
    id() {
      this.removeTelematics()
    },
    interval() {
      if (!this.showTelematics) return

      this.loadTelematics()
    }
  },
  beforeDestroy() {
    this.removeTelematics()
  },
  methods: {
    toggleTelematics() {
      if (this.showTelematics) {
        this.removeTelematics()
      } else {
        this.loadTelematics()
      }
    },
    removeTelematics() {
      this.showTelematics = false
      this.tableData = []

      this.$store.commit('MT_TMC_SET_FIELD', {
        field: 'telematicsData',
        value: null
      })
    },
    showOnMap(row) {
      this.$store.commit('MT_TMC_SET_FIELD', {
        field: 'telematicsData',
        value: row
      })
    },
    openModal(value) {
      this.$store.commit('MT_TMC_SET_FIELD', {
        field: 'telematicsModal',
        value
      })
      this.$store.commit('OPEN_MODAL_WINDOW', 'telematics-modal')
    },
    getTrackUrl() {
      const { source, interval, info } = this

      const { from, to } = interval
      const fromInit = this.$ritmDate.date(from, null, null, 0)
      const toInit = this.$ritmDate.date(to, null, null, 59)
      const fromValue = this.$ritmDate.toIso(fromInit)
      const toValue = this.$ritmDate.toIso(toInit)

      if (info.source === 'etran') {
        const mainUrl = `ZdDislocationData?format=track&id=${info.id}`
        const filtersUrl = `&from=${fromValue}&to=${toValue}`

        return `${mainUrl}${filtersUrl}`
      } else {
        const config = {
          where: [
            { func: 'st_x', field: 'geom', op: '!=', value: 0 },
            {
              field: 'uid',
              op: '=',
              value: info.track_data_id || info.id
            },
            {
              field: 'gps_time',
              op: '>',
              value: fromValue
            },
            {
              field: 'gps_time',
              op: '<',
              value: toValue
            }
          ]
        }

        return `objectInfo/${source}?array=true&config=${JSON.stringify(config)}`
      }
    },
    async loadTelematics() {
      const { $store, info } = this

      console.log('info', info)

      if (!info.track_data_id && info.source !== 'etran') {
        const title = 'Ошибка'
        const message =
          'ID телематики отсутствует'
        this.$notify(notifyFactory('warning', title, message))
        return
      }

      const url = this.getTrackUrl()

      this.loadingTelematics = true

      try {
        const { data } = await $store.dispatch('GET_REQUEST', {
          url
        })

        this.tableData = Object.values(data).map(d => ({
          ...d,
          time: this.$ritmDate.toFormat(d.gps_time, 'DD.MM.YYYY • HH:mm:ss'),
          speed: d.speed,
          coordinates: d.geom.coordinates.join(', '),
          geom: d.geom
        }))

        if (!this.tableData.length) {
          const title = 'Данные по телематике отсутствуют'
          const message =
            'Информация о телематике ТС за указанный период отсутствует'
          this.$notify(notifyFactory('info', title, message))
          this.showTelematics = false
        } else {
          this.showTelematics = true
        }
      } catch (e) {
        throw new Error(e)
      } finally {
        this.loadingTelematics = false
      }
    }
  }
}
</script>

<style lang="scss">
.mt-telematics {
  display: grid;
  width: 100%;
  height: 100%;
  overflow: hidden;
  align-items: start;
  grid-gap: 0.5rem;
  grid-auto-flow: row;

  &__action-cell {
    display: grid;
    grid-auto-flow: column;
    grid-gap: 1rem;
    justify-content: start;

    &-button {
      border-radius: var(--border-radius);
      border: none;
      background-color: transparent;
      display: grid;
      grid-gap: 0.25rem;
      grid-auto-flow: column;
      cursor: pointer;

      &:hover {
        background-color: var(--accent_hover);
      }
    }
  }
}
</style>
